import ListingPresentationGeneratorMobilePage from '../hybrid/pages/ListingPresentationGeneratorMobilePage/listing.presentation.generator.mobile.page.vue';
import ListingPresentationMobileBasic from '../hybrid/pages/ListingPresentationMobileBasic/listing.presentation.mobile.basic.vue';
import ListingPresentationMobileCompare from '../hybrid/pages/ListingPresentationMobileCompare/listing.presentation.mobile.compare.vue';
import WorkflowClosingDatePickerPage from '../hybrid/pages/WorkflowClosingDatePickerPage/workflow.closing.date.picker.page.vue';
import WorkflowClosingDateSummaryPage from '../hybrid/pages/WorkflowClosingDateSummaryPage/workflow.closing.date.summary.page.vue';
import VuePdfDemo from '../hybrid/pages/VuePdfDemo/vue.pdf.demo.vue';
import VueChartDemo from '../hybrid/pages/VueChartDemo/vue.chart.demo.vue';

export namespace HybridRoutes {
    const prefix = '/hybrid';
    export function factory() {
        return [
            { path: `${prefix}/listing-presentation/generator`, component: ListingPresentationGeneratorMobilePage,
            },
            { path: `${prefix}/listing-presentation/basic`, component: ListingPresentationMobileBasic },
            { path: `${prefix}/listing-presentation/compare`, component: ListingPresentationMobileCompare },
            { path: `${prefix}/closing-date/datepicker`, component: WorkflowClosingDatePickerPage,
              meta: {
                title: ' '
              }
            },
            { path: `${prefix}/closing-date/summary`, component: WorkflowClosingDateSummaryPage,
              meta: {
                title: ' '
              }
            },
            { path: `${prefix}/pdf/demo`, component: VuePdfDemo },
            { path: `${prefix}/chart/demo`, component: VueChartDemo },
        ];
    }
}
